const getCookieValue = (key) => {
    return document.cookie
        .split('; ')
        .find(row => row.startsWith(`${key}=`))
        .split('=')[1];
}

const CookieUtil = {
    getUser: () => getCookieValue('user')
}

export default CookieUtil;